module.exports = __webpack_public_path__ + "static/media/wall-ganbei.332208e5.png";